<template>
  <div class="NewsDetails">
    <banner img="../assets/img/bgtop.jpg" title="新闻资讯" />
    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">
        <div class="cover-wrap" v-if="newsIdList.Img">
          <img v-lazy="getImageUrl(newsIdList.Img)" alt="" />
        </div>

        <h1 class="product-title">{{ newsIdList.Title }}</h1>
        <div class="title-divider" aria-hidden="true"></div>

        <div class="article-meta" v-if="newsIdList.Title">
          <span class="article-type">{{ typeLabel }}</span>
          <span class="article-time">{{ displayTime }}</span>
        </div>

        <div
          class="product-content"
          v-html="formattedContent"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import builtInMock from '@/mock/news.json'
import { formatNewsContent } from '@/utils/newsContent'
export default {
  name: "NewsDetails",
  components: {
    Banner
  },
  data() {
    return {
      pid: 0,
      newsIdList: {}
    };
  },
  computed: {
    typeLabel() {
      const t = Number(this.newsIdList.Type);
      if (t === 1) return '公司新闻';
      if (t === 2) return '行业动态';
      return '新闻资讯';
    },
    displayTime() {
      const raw = this.newsIdList.CreateTime || '';
      if (!raw) return '';
      // 展示为 YYYY-MM-DD HH:mm
      const m = String(raw).match(/^(\d{4}-\d{2}-\d{2})[ T]?(\d{2}:\d{2})?/);
      if (!m) return raw;
      return m[2] ? `${m[1]} ${m[2]}` : m[1];
    },
    formattedContent() {
      return formatNewsContent(this.newsIdList.Content);
    }
  },
  created() {
    this.pid = this.$route.params.id;
  },
  mounted() {
    this.loadData();
  },
  watch: {
    '$route.params.id'(id) {
      this.pid = id;
      this.loadData();
    }
  },
  methods: {
    getImageUrl(imgPath) {
      if (!imgPath) return '';
      return require(`@/assets/${imgPath}`);
    },
    async loadData() {
      const newList = builtInMock || [];
      const pidStr = String(this.pid);
      const found = newList.find(item => String(item.Id) === pidStr);
      if (found) {
        this.newsIdList = found;
      } else {
        const foundBuiltin = (builtInMock.news || []).find(
          item => String(item.Id) === pidStr
        );
        if (foundBuiltin) this.newsIdList = foundBuiltin;
        else if (this.$message) this.$message.warning('未找到对应的案例条目');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  height: 100%;
  background-color: #14679f;

  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;

    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0 70px;

      .cover-wrap {
        width: 100%;
        overflow: hidden;
        background: #f0f4f8;

        img {
          display: block;
          width: 100%;
          max-height: 430px;
          object-fit: cover;
          vertical-align: top;
        }
      }

      .article-meta {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px 20px;
        width: 100%;
        margin-top: 4px;
        margin-bottom: 8px;
        font-size: 13px;
        color: #7a8a99;
        letter-spacing: 0.02em;
      }

      .article-type {
        display: inline-block;
        padding: 3px 10px;
        color: #14679f;
        background: rgba(20, 103, 159, 0.08);
        border-left: 3px solid #14679f;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.08em;
        line-height: 1.4;
      }

      .article-time {
        position: relative;
        padding-left: 14px;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #c5d0da;
          transform: translateY(-50%);
        }
      }

      .product-title {
        width: 100%;
        margin: 0;
        padding: 28px 0 0;
        font-size: 26px;
        font-weight: 700;
        line-height: 1.45;
        color: #e13834;
        letter-spacing: 0.02em;
      }

      .title-divider {
        width: 48px;
        height: 3px;
        margin: 18px 0 8px;
        background: linear-gradient(90deg, #e13834 0%, #14679f 100%);
      }

      .product-content {
        width: 100%;
        padding: 12px 0 0;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.9;
        color: #333;
        letter-spacing: 0.03em;
        word-break: break-word;

        ::v-deep p {
          margin: 0 0 1.15em;
          text-indent: 2em;
          text-align: justify;
        }

        ::v-deep .article-lead {
          margin-bottom: 1.35em;
          padding: 14px 18px;
          text-indent: 0;
          font-size: 16px;
          font-weight: 500;
          line-height: 1.85;
          color: #1a3a52;
          background: linear-gradient(
            90deg,
            rgba(20, 103, 159, 0.07) 0%,
            rgba(20, 103, 159, 0.02) 100%
          );
          border-left: 3px solid #14679f;
        }

        ::v-deep .article-quote,
        ::v-deep blockquote {
          margin: 1.4em 0;
          padding: 16px 20px 16px 22px;
          background: #f7f9fb;
          border-left: 3px solid #e13834;
          color: #445566;

          p {
            margin: 0;
            text-indent: 0;
            font-size: 15px;
            line-height: 1.8;
            color: inherit;
          }
        }

        ::v-deep h1,
        ::v-deep h2,
        ::v-deep h3,
        ::v-deep h4 {
          margin: 1.5em 0 0.75em;
          font-weight: 700;
          color: #14679f;
          letter-spacing: 0.04em;
          text-indent: 0;
        }

        ::v-deep h1 {
          font-size: 22px;
        }

        ::v-deep h2 {
          font-size: 20px;
          padding-bottom: 8px;
          border-bottom: 1px solid #e8eef3;
        }

        ::v-deep h3 {
          font-size: 17px;
        }

        ::v-deep h4 {
          font-size: 16px;
        }

        ::v-deep ul,
        ::v-deep ol {
          margin: 0.8em 0 1.2em;
          padding-left: 2.2em;

          li {
            margin-bottom: 0.45em;
            line-height: 1.8;
            text-indent: 0;
          }
        }

        ::v-deep strong {
          color: #1a3a52;
          font-weight: 700;
        }

        ::v-deep em {
          font-style: italic;
        }

        ::v-deep a {
          color: #14679f;
          text-decoration: underline;
          word-break: break-all;
        }

        ::v-deep img {
          display: block;
          max-width: 100%;
          height: auto;
          margin: 1.2em auto;
        }

        ::v-deep p img {
          margin-top: 0.4em;
          margin-bottom: 0.4em;
        }

        /* 正文插图段落不要首行缩进 */
        ::v-deep p:has(> img:only-child) {
          text-indent: 0;
        }

        ::v-deep hr {
          border: none;
          border-top: 1px dashed #d5dee6;
          margin: 1.8em 0 1em;
        }

        ::v-deep code {
          padding: 0.15em 0.4em;
          font-size: 0.9em;
          background: #f0f4f8;
          border-radius: 2px;
          color: #c0392b;
        }

        ::v-deep pre {
          margin: 1.2em 0;
          padding: 14px 16px;
          overflow-x: auto;
          background: #f5f7fa;
          border: 1px solid #e8eef3;

          code {
            padding: 0;
            color: #333;
            background: transparent;
          }
        }

        ::v-deep table {
          width: 100%;
          margin: 1.2em 0;
          border-collapse: collapse;
          font-size: 15px;

          th,
          td {
            padding: 10px 12px;
            border: 1px solid #d5dee6;
            text-align: left;
            text-indent: 0;
            vertical-align: top;
          }

          th {
            background: #f0f4f8;
            color: #14679f;
            font-weight: 600;
          }
        }

        ::v-deep .article-end {
          margin-top: 0.4em;
          padding-top: 0;
          border-top: none;
          text-indent: 0;
          text-align: right;
          font-size: 14px;
          color: #7a8a99;
        }
      }
    }
  }
}
</style>
